import _ from 'lodash'

export default (namespace, computedNameOrFuncs, funcs) => {
  let computedName = computedNameOrFuncs
  let functions = funcs

  if (_.isObject(computedNameOrFuncs)) {
    computedName = namespace
    functions = computedNameOrFuncs
  }

  return {
    computed: {
      [computedName || namespace] () {
        let entities = this.$store.getters[`${namespace}/data`](this.$store.dispatch)

        if (functions && functions.filter) {
          entities = entities.filter(functions.filter.bind(this))
        }

        if (functions && functions.map) {
          entities = entities.map(functions.map.bind(this))
        }

        return entities
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/findAll.js